module.exports = __webpack_public_path__ + "assets/img/img27.b8af817e.png";